import { useCallback, useEffect, useMemo, useReducer } from 'react';
import Helmet from 'react-helmet';

import { AppContent } from 'twyne-new.ui';

import { CodeEditorProvider } from '../CodeEditor/context';

import { FormContext, FormContextDefinition, FormStatusDefinition } from './context';

export default function FormWrapper({ title, children }) {
  const initialState = useMemo(() => new FormStatusDefinition, [])

  const [status, setStatus] = useReducer((prev, next) => ({ ...prev, ...next }), initialState)

  useEffect(() => () => setStatus(initialState), [initialState])

  const handleStatus = useCallback(status => setStatus(status), [])

  const value = new class extends FormContextDefinition {
    status = status
    handleStatus = handleStatus
  }

  return <FormContext.Provider value={value}>
    <AppContent className='overflow-hidden'>
      <CodeEditorProvider>
        <Helmet title={title} />
        {children}
      </CodeEditorProvider>
    </AppContent>
  </FormContext.Provider>
}
